/** Helper Functions **/
// Update a specific node in the graph
export function updateNodeInGraph(prevGraph, nodeId, newProperties) {
  const updatedNodes = prevGraph.nodes.map((node) => node.id === nodeId ? { ...node, ...newProperties } : node
  );
  return { ...prevGraph, nodes: updatedNodes };
}
